import { useEffect, useState } from 'react';

export interface ViewportSize {
  width: number;
  height: number;
}

/** The live viewport size, kept current across window resizes and rotations. */
export function useViewportSize(): ViewportSize {
  const [size, setSize] = useState<ViewportSize>(() => ({
    width: window.innerWidth,
    height: window.innerHeight,
  }));

  useEffect(() => {
    const read = () => setSize({ width: window.innerWidth, height: window.innerHeight });
    window.addEventListener('resize', read);
    window.addEventListener('orientationchange', read);
    return () => {
      window.removeEventListener('resize', read);
      window.removeEventListener('orientationchange', read);
    };
  }, []);

  return size;
}
